import { pick, get } from "lodash";
import { WORKER_FILTERS, FILTER_GROUPS } from "@/constants/workers";

export const getAwrStatus = isAWR => (isAWR ? "Post-AWR" : "Pre-AWR");

export const getWorkerData = worker =>
  pick(worker, [
    "id",
    "type",
    "firstName",
    "lastName",
    "dob",
    "email",
    "phone",
    "gender",
    "cv",
    "awr",
    "dda",
    "countryOfBirth",
    "ethnicGroupId",
    "utr",
    "yearsReferenced",
    "ethnicOrigin",
    "address",
    "company",
    "companyAddress",
    "references",
    "addresses",
    "intermediaryOrganisation",
    "userReferences"
  ]);

export const getColorByStatus = status => {
  return status === "active" ? "green" : "red";
};

const getDefaultFilters = () => {
  const {
    minimum_salary,
    applications_created_before,
    applications_created_after,
    interviews_date_before,
    interviews_date_after
  } = WORKER_FILTERS;

  return {
    [FILTER_GROUPS.preferences]: { minimum_salary },
    [FILTER_GROUPS.applications]: {
      applications_created_before,
      applications_created_after
    },
    [FILTER_GROUPS.interviews]: {
      interviews_date_before,
      interviews_date_after
    }
  };
};

export const getGroupedFilters = filters => {
  return Object.keys(filters).reduce((groupedFilters, filterName) => {
    const groupName = get(WORKER_FILTERS[filterName], "group");
    if (!groupName) {
      return groupedFilters;
    }
    if (!groupedFilters[groupName]) {
      groupedFilters[groupName] = {
        [filterName]: filters[filterName]
      };
    } else {
      groupedFilters[groupName] = {
        ...groupedFilters[groupName],
        [filterName]: filters[filterName]
      };
    }
    return groupedFilters;
  }, getDefaultFilters());
};
